import React, { useState, useEffect, useRef } from "react";
import DataTable from "react-data-table-component";
import CustomPagination from "../CustomPagination/CustomPagination";
import CSVDownloadButton from "../CsvDownload/CsvDownload";
import Nav from "react-bootstrap/Nav";
import "./datatable.css";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite-no-reset.min.css";
import arrowIcon from "../../Assets/Svg/arrow-icon.svg";
import deleteIcon from "../../Assets/Svg/Delete-icon.svg";
import expoIcon from "../../Assets/Svg/Expo-Icon.svg";
import timeLine from "../../Assets/Svg/TimeLine.svg";
import downloadBlackIcon from "../../Assets/Svg/download-black.svg";
import VendorHistoryIcon from "../../Assets/Svg/vendor-history.svg";
import TimeStamp from "../../Models/TimeStamp/TimeStamp";
import ViewIssuePopup from "../../Models/ViewIssuePopup/ViewIssuePopup";
import CustomPopup from "./../../Models/CustomPopup/CustomPopup";
import areIcon from "../../Assets/Svg/areyousure-icon.svg";
import successIcon from "../../Assets/Svg/success-icon.svg";
import RejectVendorPopup from "../../Models/RejectVendorPopup/RejectVendorPopup";
import { useNavigate, useRouteError } from "react-router-dom";
import { getVendorListTableData } from "../../Store/Reducer/vendorTable";
import { useDispatch, useSelector } from "react-redux";
import {
  DateGenerator,
  decryptData,
  transformVendorTableDataResponse,
} from "../../Utils/Utils";
import {
  approveAllRequest,
  currentVendorRowData,
  getVendorHistoryExportAction,
} from "../../Store/actions/vendorMangementAction";
import useDecryptedData from "../../CustomHooks/useDecryptedData";
import { tableStyles } from "../../Utils/TableStyles";
import { clearLatestVendorInfo } from "../../Store/actions/updateVendorAction";
import { useTranslation } from "react-i18next";
import VendorHistory from "../../Models/VendorHistory/VendorHistory";
import ActivityPopup from "../../Models/ActivityPopup";
import { vendorData } from "../../Utils/mockhistoryData";
import { BufferToExcel } from "../../Utils/BufferToExcel";
import { toast } from "react-toastify";
import { PageLoader } from "../Imports/import";

const VendorManagementTable = ({ setPageLoading = false }) => {
  const dispatch = useDispatch();
  const workerRef = useRef(null);
  const { vendorList, loading } = useSelector((state) => state.vendorTableList);

  const { res_data, TotalCount } = vendorList || {};
  const data = transformVendorTableDataResponse(res_data);
  const { t } = useTranslation();

  const navigate = useNavigate();
  const name = localStorage.getItem("loginDetailsName")

  const [searchValues, setSearchValues] = useState({
    name: name
  });
  const [exportLoader, setExportLoader] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [type, setType] = useState("all");
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [showPopup, setShowPopup] = useState({
    viewIssue: false,
    timeLine: false,
    showApprove: false,
    showReject: false,
    deleteVendor: false,
    showVendorHistory: false,
  });
  const [rowData, setRowData] = useState({});
  const [count, setCount] = useState(TotalCount || 0);
  const [tableParams, setTableParams] = useState({
    page: currentPage,
    pageSize: itemsPerPage,
    orderBy: "updated_at",
    orderDir: "DESC",
    searchBy: null,
    searchColumns: [],
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    setCount(TotalCount);
  }, [TotalCount]);
  const page = currentPage;
  const pageSize = itemsPerPage;
  const orderBy = tableParams?.orderBy;
  const orderDir = tableParams?.orderDir;
  const searchBy = tableParams?.searchBy;
  const searchColumns = tableParams?.searchColumns;
  const startDate = tableParams?.startDate;
  const endDate = tableParams?.endDate;

  const secretKey = "mysecretkey12345";

  const encryptedUser = localStorage.getItem("encryptedUserInfo");
  const userInfoObject = decryptData(encryptedUser, secretKey);

  const columnWidths = {
    "Vendor Code": "10%",
    "Company Name": "10%",
    "Bidding Category": "10%",
    Date: "10%",
    "Current Group": "10%",
  };

  const [key, setKey] = useState(1);
  const [payload, setPayload] = useState(null);
  const [showDeletePopup, setShowDeletePopup] = useState(false);

  const handleApproveAll = (rowData) => {
    const vendorId = rowData?.vendor_id;
    setPayload(vendorId);
  };

  const removePopup = () => {
    setShowDeletePopup(false);
    setPayload(null);
  };

  useEffect(() => {
    if (payload) {
      setShowDeletePopup(true);
      setKey((prev) => prev + 1);
    }
  }, [payload]);

  const columns = [
    {
      id: "vendor_code",
      name: t("Vendor Code"),
      selector: (result) => result?.vendor_code,
      searchable: true,
      width: "11%",
    },
    {
      id: "company_name_eng",
      name: "Company Name",
      selector: (result) => result?.company_name_eng,
      searchable: true,
      width: "12%",
    },
    {
      id: "binding_category",
      name: "Bidding Category",
      selector: (result) =>
        result?.binding_category?.includes("Other")
          ? result.binding_category_specify
          : result.binding_category,
      searchable: true,
      width: "10%",
    },
    {
      id: "created_at",
      name: "Date",
      selector: (result) => DateGenerator(result?.Date),
      searchable: true,
      width: "11%",
    },
    {
      id: "rejected_by_group_name" && "current_group_name",
      name: "Current Group",
      searchable: true,
      width: "14%",
      selector: (result) => (
        <p
          className={
            result?.vendor_status === "Rejected"
              ? "table-status vm-status-reject"
              : "table-status vm-status-approve"
          }
        >
          {result?.vendor_status === "Rejected"
            ? result?.current_group_name === "Exit"
              ? "Vendor"
              : result?.current_group_name === "Buyer Group"
              ? result?.current_stage_user_name
              : result?.current_group_name
            : result?.current_group_name === "Buyer Group"
            ? result?.current_stage_user_name
            : result?.current_group_name}
        </p>
      ),
    },
    {
      id: "name",
      name: "Name",
      searchable: true,
      selector: (result) => result?.name,
      width: "10%",
    },
    {
      id: "vendor_status",
      name: "Status",
      cell: (result) => (
        <p
          className={
            result?.vendor_status === "Rejected"
              ? "table-status vm-status-reject"
              : result.vendor_status === "Pending"
              ? "table-status vm-status-pending"
              : "table-status vm-status-approve"
          }
        >
          {result?.vendor_status}
        </p>
      ),
      searchable: true,
      width: "8%",
    },
    {
      id: "Action",
      name: "Action",
      cell: (result) => (
        <>
          <button
            className="table-btn"
            onClick={() => {
              handleChangeView(result);
            }}
          >
            View
          </button>
        </>
      ),
      searchable: false,
      width: "8%",
    },
    {
      id: "Approve",
      selector: "Approve",
      cell: (result) => {
        const userIdMatched =
          decryptedData?.user_id == result?.current_stage_user_id;
        const checkGroupMatch = decryptedData?.assigner_type?.includes(
          result?.current_group_name
        );

        const isRoleAssigner =
          decryptedData?.assigner_type?.includes("Assigner");

        const checkCurrentGroupRoleIsAssigner =
          result?.current_group_name?.includes("Assigner") ?? true;

        const isVendorRejected = result?.vendor_status == "Rejected";

        const checkCurrentRoleIsAdmin = decryptedData?.role === "Admin";

        return (
          <div className="d-flex">
            {userInfoObject?.role === "Admin" &&
              ![
                "Buyer Group",
                "Assigner 1",
                "Assigner 2",
                "Assigner 3",
              ].includes(result?.current_group_name) &&
              result?.vendor_code &&
              result.vendor_code !== "---" &&
              result?.vendor_status !== "Approved" && (
                <button
                  className="table-btn-approve"
                  onClick={() => handleApproveAll(result)}
                >
                  Approve All
                </button>
              )}
            {checkGroupMatch &&
              result?.current_group_name != "Admin" &&
              result?.vendor_status != "Approved" &&
              userIdMatched && (
                <>
                  <button
                    className="table-status vm-approve mx-2"
                    onClick={() => {
                      handleChangeColumn(result, { showApprove: true });
                    }}
                  >
                    Approve
                  </button>
                  {!isRoleAssigner && (
                    <button
                      className="table-status vm-reject mx-2"
                      onClick={() => {
                        handleChangeColumn(result, { showReject: true });
                      }}
                    >
                      Reject
                    </button>
                  )}
                </>
              )}
            {isVendorRejected && (
              <button
                className="mx-2"
                onClick={() => {
                  handleChangeColumn(result, { viewIssue: true });
                }}
              >
                <img src={expoIcon} alt="" />
              </button>
            )}
            {checkCurrentRoleIsAdmin && (
              <button
                className="mx-2"
                onClick={() => {
                  handleChangeColumn(result, { deleteVendor: true });
                }}
              >
                <img src={deleteIcon} alt="delete" />
              </button>
            )}
            {(
              <button
                className="mx-2"
                onClick={() => {
                  handleChangeColumn(result, { timeLine: true });
                }}
              >
                <img src={timeLine} alt="" />
              </button>
            )}
            {result?.keys_updated === 1 && (
              <button
                className="mx-2"
                onClick={() => {
                  handleChangeColumn(result, { showVendorHistory: true });
                }}
              >
                <img src={VendorHistoryIcon} alt="" />
              </button>
            )}
          </div>
        );
      },
      searchable: false,
      width: "20%",
    },
  ];

  const handleChangeView = (result) => {
    dispatch(clearLatestVendorInfo());
    localStorage.setItem("vendor_id", result.vendor_id);
    navigate("/vendor-profile");
  };

  const handleChangeColumn = (result, obj) => {
    dispatch(currentVendorRowData(result));
    setShowPopup(obj);
    setRowData(result);
  };

  const handlePageChange = (page) => {
    setTableParams({
      ...tableParams,
      page,
    });
    setCurrentPage(page);
  };

  // handleing the sort functionality
  const handleDropdownChange = (e) => {
    const selectedItemsPerPage = parseInt(e.target.value, 10);
    setItemsPerPage(selectedItemsPerPage);
    setCurrentPage(1);
  };

  // handling the search functionality
  const handleSearchChange = (event, columnName) => {
    setCurrentPage(1);
    const { value } = event.target;
    setSearchValues((prevSearchValues) => ({
      ...prevSearchValues,
      [columnName]: value,
    }));
  };

  const handleTypeSelect = (selectedKey) => setType(selectedKey);

  const filterData = () => {
    let filteredData = [...data];
    for (const columnName in searchValues) {
      const searchValue = searchValues[columnName];
      if (searchValue) {
        filteredData = filteredData?.filter((item) => {
          return item[columnName]
            ?.toLowerCase()
            ?.includes(searchValue?.toLowerCase());
        });
      }
    }

    if (selectedDateRange[0] && selectedDateRange[1]) {
      filteredData = filteredData.filter((item) => {
        const registerDate = new Date(item.Date);
        return (
          registerDate >= selectedDateRange[0] &&
          registerDate <= selectedDateRange[1]
        );
      });
    }

    return filteredData;
  };

  const handleDateRangeChange = (newDateRange) => {
    setSelectedDateRange(newDateRange);
    updateTableParams(newDateRange);
  };

  const handleDateRangeClean = () => {
    if (selectedDateRange && selectedDateRange.length > 0) {
      setSelectedDateRange([]);
      updateTableParams([]);
    }
  };

  const filteredData = filterData();

  const displayedRange = {
    start: (currentPage - 1) * itemsPerPage + 1,
    end: Math.min(currentPage * itemsPerPage, count),
    total: filteredData.length,
  };

  const updateTableParams = (newDateRange) => {
    if (newDateRange && newDateRange.length === 2) {
      const formattedStartDate = newDateRange[0]?.toISOString().split("T")[0];
      const formattedEndDate = newDateRange[1]?.toISOString().split("T")[0];
      setTableParams((prevParams) => ({
        ...prevParams,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
      }));
    } else {
      setTableParams((prevParams) => ({
        ...prevParams,
        startDate: null,
        endDate: null,
      }));
    }
  };
  const headerNames = columns.map((column) => column?.name);
  const csvData = data.map((item) =>
    columns.map((column) => {
      if (column.id === "created_at") {
        return DateGenerator(item.Date).toString();
      }
      if (column.id === "vendor_status") {
        return item?.vendor_status == "Pending"
          ? "Waiting For Approval"
          : item?.vendor_status;
      }
      return item[column.id];
    })
  );
  const closeTimeLine = () => {
    setShowPopup(false);
  };

  const closeVendorHistory = () => {
    setShowPopup(false);
  };

  // calling vendor data

  useEffect(() => {
    // setPageLoading(loading);
    if (!showDeletePopup && name) {
      dispatch(
        getVendorListTableData({
          page,
          pageSize,
          orderBy,
          orderDir,
          searchBy,
          searchColumns,
          startDate,
          endDate,
          searchValues,
        })
      );
    }
  }, [tableParams, itemsPerPage, currentPage, searchValues, showDeletePopup]);

  const decryptedData = useDecryptedData("encryptedUserInfo", secretKey);

  if (!decryptedData) {
    return <div>Loading...</div>;
  }

  const handleExportHistory = () => {
    if (!workerRef?.current) {
      setExportLoader(true);
      workerRef.current = new Worker(
        new URL("../../Workers/vendorHistoryWorker", import.meta.url),
        { type: "module" }
      );

      workerRef.current.onmessage = (e) => {
        const { buffer, fileName, error } = e.data;

        if (buffer) BufferToExcel(buffer, fileName);
        if (error) {
          setExportLoader(false);
          toast.error("Failed to export. Please Try Again!");
          return;
        }
        setExportLoader(false);
      };

      workerRef.current.onerror = (err) => {
        toast.error("Failed to export. Please Try Again!");
        setExportLoader(false);
      };
    }

    dispatch(
      getVendorHistoryExportAction({
        vendorIds: data?.map((key) => key?.vendor_id),
        startDate,
        endDate,
      })
    ).then((res) => {
      if (res?.status == 200) {
        workerRef.current.postMessage({
          data: res?.data?.data || [],
          fileName: "VendorChangeHistory.xlsx",
        });
      } else {
        toast.error("Failed to export. Please Try Again!");
        setExportLoader(false);
      }
    });
  };

  return (
    <>
      {exportLoader && <PageLoader />}
      <CustomPopup
        key={key}
        isOpenPopup={showDeletePopup}
        closePopup={removePopup}
        title="Are you sure!"
        image={areIcon}
        text={"You want to all Approve this vendor?"}
        btn1="Cancel"
        btn2="Confirm"
        successTitle="Done!"
        successText={"Delete successfully"}
        successIcon={successIcon}
        btn3="Ok"
        scenarioType="approveAllVendor"
        userData={payload}
      />
      <div>
        <div className="um-table-header-div">
          <div className="um-table-head">
            <div className="table-navbar">
              <Nav activeKey="" onSelect={handleTypeSelect} className="">
                <Nav.Item>
                  <Nav.Link
                    className={
                      type === "all"
                        ? "supplier-visit-table-active"
                        : "supplier-visit-table"
                    }
                    eventKey="all"
                  >
                    All
                    <span
                      className={
                        type === "all"
                          ? "supplier-visit-table-badge-active"
                          : "supplier-visit-table-badge"
                      }
                      eventKey="all"
                    >
                      {TotalCount}
                    </span>
                  </Nav.Link>
                </Nav.Item>
              </Nav>

              <DateRangePicker
                appearance="default"
                format={"yyyy-MM-dd"}
                placement="bottomEnd"
                placeholder={"Start date ~ End date"}
                value={selectedDateRange}
                onChange={handleDateRangeChange}
                onClean={handleDateRangeClean}
              />
            </div>

            <div className="d-flex justify-content-between align-items-center um-entries-div">
              <div className="d-flex justify-content-between align-items-center um-entries">
                {" "}
                <p>Show </p>{" "}
                <select value={itemsPerPage} onChange={handleDropdownChange}>
                  <option>5</option>
                  <option>10</option>
                  <option>15</option>
                  <option>20</option>
                  <option>25</option>
                  <option>30</option>
                  <option>100</option>
                </select>{" "}
                <span>entries</span>
              </div>

              <div>
                <button
                  onClick={handleExportHistory}
                  className="history-export-button"
                >
                  <img src={downloadBlackIcon} alt="Export History" /> Export
                  History
                </button>
                <CSVDownloadButton
                  data={csvData}
                  headers={headerNames}
                  filename="VendorManagementTable_data.csv"
                />
              </div>
            </div>
          </div>
          <div
            style={{ position: "relative", margin: "0px" }}
            className={data.length ? "vm-data-table" : "vm-empty-data-table"}
          >
            <DataTable
              columns={columns}
              data={data}
              customStyles={tableStyles}
              pagination={false}
              noDataComponent="No records to display"
              persistTableHead
            />
            <div
              style={{
                position: "absolute",
                top: "50px",
                left: 0,
                right: 0,
                padding: "4px",
              }}
              className="table-search-div"
            >
              {columns.map((column) =>
                column.searchable !== false ? (
                  <input
                    key={column.id}
                    type="text"
                    value={searchValues[column.id] || ""}
                    style={{ width: column.width, marginRight: "2px" }}
                    onChange={(event) => handleSearchChange(event, column.id)}
                  />
                ) : null
              )}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center pb-4">
          <p className="um-show-entries">
            {" "}
            Showing {displayedRange.start} to {displayedRange.end} of{" "}
            {TotalCount} entries
          </p>
          <CustomPagination
            totalItems={TotalCount}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </div>

        {showPopup.timeLine && (
          <ActivityPopup
            isOpen={showPopup.timeLine}
            closeModal={closeTimeLine}
            userData={rowData}
          />
          // <TimeStamp
          //   isOpen={showPopup.timeLine}
          //   closeModal={closeTimeLine}
          //   userData={rowData}
          // />
        )}
        {showPopup.showVendorHistory && (
          <VendorHistory
            isOpen={showPopup.showVendorHistory}
            closeModal={closeVendorHistory}
            userData={rowData}
          />
        )}

        {showPopup.viewIssue && (
          <ViewIssuePopup
            isOpenPopup={showPopup.viewIssue}
            closePopup={closeTimeLine}
            userData={rowData}
          />
        )}

        {showPopup.showApprove && (
          <CustomPopup
            isOpenPopup={showPopup.showApprove}
            closePopup={closeTimeLine}
            title="Are you sure!"
            image={areIcon}
            text={"You want to Approve this Vendor ?"}
            btn1="Cancel"
            btn2="Confirm"
            successTitle="Done!"
            successText={"Approve successfully"}
            successIcon={successIcon}
            btn3="Ok"
            scenarioType="approveVendor"
            handleChangeColumn={handleChangeColumn}
            userData={rowData}
            setPageLoading={setPageLoading}
          />
        )}

        {showPopup.showReject && (
          <RejectVendorPopup
            isOpenPopup={showPopup.showReject}
            closePopup={closeTimeLine}
            userData={rowData}
            setPageLoading={setPageLoading}
          />
        )}

        {showPopup.deleteVendor && (
          <CustomPopup
            isOpenPopup={showPopup.deleteVendor}
            closePopup={closeTimeLine}
            title="Are you sure!"
            image={areIcon}
            text={"You want to Delete this Vendor ?"}
            btn1="Cancel"
            btn2="Confirm"
            successTitle="Done!"
            successText={"Delete successfully"}
            successIcon={successIcon}
            btn3="Ok"
            scenarioType="deleteVendor"
            handleChangeColumn={handleChangeColumn}
            userData={rowData}
          />
        )}
      </div>
      {/* ) : (
        <h1 className="d-flex justify-content-center align-items-center mt-5">
          No Vendors Assigned Under You
        </h1>
      )} */}
    </>
  );
};

export default VendorManagementTable;
